export default async function initProductDetail() {
	let backButton = document.querySelector('.OverlayPage-backButton a');
	if (backButton) {
		if (document.referrer.includes(location.hostname.split('.').slice(1).join('.'))) {
			backButton.href = 'javascript:void(0);';
			backButton.addEventListener('click', e => {
				e.preventDefault();
				history.back();
			});
		}
	}
}
